import React, { useState, useEffect } from 'react';
import TextFieldWithClear from '../../TextFieldWithIcon/TextFieldWithIcon';
import { connectWithRouter } from 'helpers/connectWithRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { enqueueSnackbarCustomMessage } from 'actions/Snackbar/resetSnackbar';
import Button from '@mui/material/Button';
import { FormGroup } from '@mui/material';

const styles = require('./styles.pcss');

type Props = {
  onSubmit: Function;
  className?: string;
  children?: React.ReactNode;
};

type State = {
  data: any;
};

export default class BaseForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const stateData: any = {};
    this.state = { data: stateData };
  }

  render() {
    return (
      <FormGroup className={this.props.className}>
        <div className={styles.inputContainer}>{this.props.children}</div>
        <Button
          className={styles.button}
          size="medium"
          variant="contained"
          color="primary"
          onClick={() => this.props.onSubmit(this.state.data)}
        >
          Submit
        </Button>
      </FormGroup>
    );
  }
}
